export type IsHiddenUsingStyleOptions = {
  /** The list of style properties that won't be check whether it hides the element or not */
  skipStyleProperty?: string[];
};

/**
 * Determines whether the given element is hidden using CSS
 */
export const isHiddenUsingStyle = (
  element: Element,
  style?: CSSStyleDeclaration,
  options: IsHiddenUsingStyleOptions = {},
): boolean => {
  if (!style) {
    style = window.getComputedStyle(element);
  }

  options = {
    skipStyleProperty: [],
    ...options,
  };

  const propertyAndHiddenValues = [
    {
      property: 'display',
      hiddenValues: ['none'],
    },
    {
      property: 'visibility',
      hiddenValues: ['hidden', 'collapse'],
    },
    {
      property: 'opacity',
      hiddenValues: ['0'],
    },
    {
      property: 'filter',
      hiddenValues: ['opacity(0)'],
    },
  ];

  return propertyAndHiddenValues.some(({ property, hiddenValues }) => {
    if (
      !style ||
      !(property in style) ||
      options.skipStyleProperty?.includes(property)
    ) {
      return false;
    }

    const value = style[property as keyof typeof style];

    return typeof value === 'string' && hiddenValues.includes(value);
  });
};
